'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _styles = require('@material-ui/core/styles');

var _Button = require('@material-ui/core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _util_file = require('../utils/util_file');

var _action_form = require('../actions/action_form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles() {
  return {
    root: {
      float: 'left'
    },
    btnRefresh: {
      borderRadius: 5,
      height: 34,
      padding: '4px 10px 4px 10px'
    },
    icon: {}
  };
};

var btnSubmit = function btnSubmit(classes, isValidExt, submitFormAct) {
  return _react2.default.createElement(
    _Button2.default,
    {
      disabled: !isValidExt,
      size: 'small',
      variant: 'fab',
      color: 'primary',
      className: (0, _classnames2.default)(classes.btnRefresh),
      onClick: submitFormAct
    },
    _react2.default.createElement(
      'span',
      { className: (0, _classnames2.default)(classes.subBtn, 'txt-sv-subBtn') },
      'Submit'
    )
  );
};

var InputForm = function InputForm(_ref) {
  var classes = _ref.classes,
      fileSt = _ref.fileSt,
      submitFormAct = _ref.submitFormAct;
  var src = fileSt.src;

  var isValidMsExt = (0, _util_file.VerifyMsExt)(src);
  var isValidJcampExt = (0, _util_file.VerifyJcampExt)(src);
  var isValidExt = isValidMsExt || isValidJcampExt;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(classes.root) },
    btnSubmit(classes, isValidExt, submitFormAct)
  );
};

var mapStateToProps = function mapStateToProps(state, props) {
  return (// eslint-disable-line
    {
      fileSt: state.file
    }
  );
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    submitFormAct: _action_form.submitForm
  }, dispatch);
};

InputForm.propTypes = {
  fileSt: _propTypes2.default.object.isRequired,
  submitFormAct: _propTypes2.default.func.isRequired,
  classes: _propTypes2.default.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _styles.withStyles)(styles)(InputForm));